/**
 * Frequently asked questions array of objects.
 * NOTE: These questions contain HTML for styling purposes, so when using them
 * in a Vue component template, ensure you're using the v-html property,
 * instead of mustache tags {{ }}.
 */
export const FAQS = [
  {
    question: `How exactly does SideSearch work?`,
    answer: `Very simply, SideSearch is a platform to encourage engagement and meaningful conversations between potential passive/active Candidates and Companies who are hiring. 
            <br /><br />You build your Confidential Employment Profile (CEP)...Companies search and send you a message...it’s up to you where you take it from there. 
            <br /><br />Our hope is these meaningful conversations improve the quality of the search, on both sides, and lead to securing employment with a reputable organization.`,
    isOpen: false
  },
  {
    question: `Why should I care if my job search is confidential?`,
    answer: `Fair question. What, do you not like privacy?
            <br /><br />SideSearch was borne out of caution (and paranoia) as it relates to who should be privy that you are actively or passively looking for a new role. 
            <br /><br />Why does your current employer need to know you are looking? And should they know? 
            Yup, that’s the point, you are free to roam without fear of retaliation from your current boss, peer network, or spies.`,
    isOpen: false
  },
  {
    question: `How am I notified when I receive a message from potential Company?`,
    answer: `Easy, you will receive a message in your SideSearch inbox and you will also receive an
            email (the email address you used to sign up).`,
    isOpen: false
  },
  {
    question: `How do I communicate with a potential Company while remaining anonymous?`,
    answer: `Good news, you’ve come to the right place, all a Company sees is your user name.
            This gives you the freedom to communicate on your terms. When you are ready, you can reveal your identity to the employer...it’s up to you!`,
    isOpen: false
  },
  {
    question: 'Do I have to reveal my identity?',
    answer: `<em>Candidates</em> -- No, that is the beauty. It is completely up to you the timing and forum (SideSearch message, email, phone call, carrier pigeon) with which you reveal who you are.
            <br /><br /><em>Companies</em> -- Yes, this is revealed at the onset of your conversation.`,
    isOpen: false
  },
  {
    question: `Where are the job postings?`,
    answer: `SideSearch does not post open positions, that ball is in the Companies’ court. 
            Rather, we are a forum for introduction between Candidates and Companies who hire.
            <br /><br />Upon receiving a message from the Company, any postings & applications will be handled directly between the two of you.`,
    isOpen: false
  },
  {
    question: `Can I upload my resume?`,
    answer: `No, that is what your Confidential Employment Profile (CEP) is for...a measurable snapshot of your skillset and professional background.
            <br /><br />Should you want to send your resume directly to the Company, that is totally up to you, however, that endeavor isn’t currently our function.`,
    isOpen: false
  },
  {
    question: `How do I edit my Confidential Employment Profile (CEP)?`,
    answer: `Login and go to your Account → Click the editing Pencil → this will reveal sub-Pencils to allow you to edit → Save → Rinse and Repeat if needed `,
    isOpen: false
  },
  {
    question: `How do I contact a potential Candidate?`,
    answer: `Company representatives can easily message a potential candidate by the following:
            <br />Login → Run your search query → Choose the profile you’d like to contact and click “View Profile” → This will reveal the full Confidential Employment Profile and enable the Message function → Button is on your right`,
    isOpen: false
  },
  {
    question: `How are SideSearch Candidates any different than other candidates on the “usual” job boards?`,
    answer: `Let’s face it, the best candidates are usually passive and never on the open market with the “usual” job boards.`,
    isOpen: false
  },
  {
    question: `How do I delete my account?`,
    answer: `Well, we think that’s a poor decision and we hate to see you go…
        If you must, please send a request to our support team by clicking <a href="https://forms.gle/SoTfGSweMNG2FZ7e7">HERE</a>.`,
    isOpen: false
  }
];
